import React from 'react';
import PreferencesMenu from './PreferencesMenu';

const MessageToolbar = ({
    selectedMessageIds,
    activeTab,
    setActiveTab,
    preferencesRef,
    showPreferencesMenu,
    setShowPreferencesMenu,
    messageViewMode,
    setMessageViewMode,
    sortOrder,
    setSortOrder,
    preferenceFilters,
    setPreferenceFilters,
    showMoreFilters,
    setShowMoreFilters,
    filteredMessages,
    setSelectedMessageIds,
    handleBulkArchive,
    handleBulkDelete,
    handleBulkMarkRead,
    handleBulkSpam,
    toolbarMoreRef,
    showMoveMenu,
    setShowMoveMenu,
}) => {
    return (
        <div className="message-toolbar">
            {selectedMessageIds.length === 0 ? (
                <div className="mail-category-row">
                    {['all', 'primary', 'parent', 'staff', 'billing'].map((tab) => (
                        <button
                            key={tab}
                            type="button"
                            className={activeTab === tab ? 'mail-tab active' : 'mail-tab'}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab === 'parent'
                                ? 'Parent Mail'
                                : tab.charAt(0).toUpperCase() + tab.slice(1)}
                        </button>
                    ))}

                    <div className="preferences-shell" ref={preferencesRef}>
                        <button
                            type="button"
                            className="preferences-btn"
                            onClick={() => setShowPreferencesMenu((prev) => !prev)}
                            title="Preferences"
                        >
                            ⚙
                        </button>

                        <PreferencesMenu
                            showPreferencesMenu={showPreferencesMenu}
                            messageViewMode={messageViewMode}
                            setMessageViewMode={setMessageViewMode}
                            sortOrder={sortOrder}
                            setSortOrder={setSortOrder}
                            preferenceFilters={preferenceFilters}
                            setPreferenceFilters={setPreferenceFilters}
                            showMoreFilters={showMoreFilters}
                            setShowMoreFilters={setShowMoreFilters}
                        />
                    </div>
                </div>
            ) : (
                <>
                    <select
                        className="message-select-menu"
                        onChange={(e) => {
                            if (e.target.value === 'none') {
                                setSelectedMessageIds([]);
                            }

                            if (e.target.value === 'all') {
                                setSelectedMessageIds(
                                    filteredMessages.map((msg) => msg._id)
                                );
                            }
                        }}
                    >
                        <option>{selectedMessageIds.length} selected</option>
                        <option value="all">All</option>
                        <option value="none">None</option>
                        <option value="read">Read</option>
                        <option value="unread">Unread</option>
                        <option value="starred">Starred</option>
                        <option value="unstarred">Unstarred</option>
                    </select>

                    <button
                        type="button"
                        className="message-toolbar-action-btn"
                        title="Archive selected"
                        onClick={handleBulkArchive}
                    >
                        📥
                    </button>

                    <button
                        type="button"
                        className="message-toolbar-action-btn"
                        title="Delete selected"
                        onClick={handleBulkDelete}
                    >
                        🗑️
                    </button>

                    <button
                        type="button"
                        className="message-toolbar-action-btn"
                        title="Mark as read"
                        onClick={handleBulkMarkRead}
                    >
                        ✉️
                    </button>

                    <button
                        type="button"
                        className="message-toolbar-action-btn"
                        title="Mark as spam"
                        onClick={handleBulkSpam}
                    >
                        🛡️
                    </button>

                    <div className="toolbar-more-shell" ref={toolbarMoreRef}>
                        <button
                            type="button"
                            className="message-toolbar-action-btn"
                            title="More options"
                            onClick={() => setShowMoveMenu((prev) => !prev)}
                        >
                            …
                        </button>

                        {showMoveMenu && (
                            <div className="toolbar-more-menu">
                                <button type="button">⭐ Star</button>
                                <button type="button">🚫 Block sender</button>
                                <button type="button">🗑️ Delete all from sender</button>
                                <button type="button">🚫 Unsubscribe</button>
                                <button type="button">📄 View raw message</button>
                                <button type="button">🖨️ Print</button>
                                <button type="button">👤 Add sender to contacts</button>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default MessageToolbar;